/*
 * Invoca wrapper for Toastr
 */

import _ from "underscore";
import toastr from "toastr";

const Toast = (function() {
  var defaultOptions = {
    showDuration: 300,
    hideDuration: 300,
    timeOut: 3000,
    extendedTimeOut: 5000,
    preventDuplicates: false,
    progressBar: false,
    sticky: false,
    action: undefined,
    title: undefined,
    message: undefined,
    closeButton: false
  };

  function _show(type, userConfig) {
    var config  = _setup(type, userConfig);

    // Show toast message and return toast element
    return toastr[type](config.message, config.title, config);
  }

  function _setup(messageType, userConfig) {
    if (typeof userConfig === 'string') {
      userConfig = {
        title: userConfig,
        message: ' '
      };
    }

    if (messageType === 'error') {
      userConfig.sticky = true;
    }

    if (userConfig.sticky) {
      userConfig.timeOut = 0;
      userConfig.extendedTimeOut = 0;
      userConfig.closeButton = true;
    }

    return _.extend({}, defaultOptions, userConfig);
  }

  var Toast = {
    defaults: defaultOptions,
    notice: function(userConfig) {
      return _show('success', userConfig);
    },
    clear: function(toastElement) {
      toastr.clear(toastElement);
    },
    showError: function(message) {
      return _show('error', {
        title: message,
        sticky: true,
        tapToDismiss: false
      });
    }
  };

  ['success', 'error', 'warning', 'info'].forEach(function(type) {
    Toast[type] = function(userConfig) {
      return _show(type, userConfig);
    };
  });

  return Toast;
})();

export default Toast;
